import { Components, Theme, ThemeOptions } from '@mui/material/styles';

const getMenuTheme = (theme: Theme): ThemeOptions => {
  // ─────────────────────────────────────────────────────────
  // MUI MENU THEME
  // ─────────────────────────────────────────────────────────
  const menuTheme: Components<Theme>['MuiMenu'] = {
    defaultProps: {
      elevation: 2,
      anchorOrigin: { vertical: 'bottom', horizontal: 'left' },
      transformOrigin: { vertical: 'top', horizontal: 'left' },
    },
    styleOverrides: {
      paper: {
        display: 'flex',
        width: theme.unit(50),
        minWidth: theme.unit(28),
        maxWidth: theme.unit(70),
        padding: theme.unit(2, 0),
        alignItems: 'flex-start',
        borderRadius: theme.unit(2),
        background: theme.palette.M3.sys.light['surface-container'],
      },
      list: {
        width: '100%',
        padding: 0,
      },
    },
  };

  // ─────────────────────────────────────────────────────────
  // MUI MENU ITEM THEME
  // ─────────────────────────────────────────────────────────
  const menuItemTheme: Components<Theme>['MuiMenuItem'] = {
    styleOverrides: {
      root: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        gap: theme.unit(3),
        alignSelf: 'stretch',
        padding: theme.unit(2.5, 4),
        borderRadius: 0,
        ...theme.typography.M3.body.medium,
        color: theme.palette.M3.sys.light['on-surface'],
        '& .MuiListItemIcon-root': {
          minWidth: 0,
          marginRight: theme.unit(3),
          color: theme.palette.M3.sys.light['on-surface-variant'],
        },
        '& .MuiSvgIcon-root': {
          fontSize: '20px',
        },
        '&:hover': {
          backgroundColor: theme.palette.M3.sys.light['secondary-container'],
          color: theme.palette.M3.sys.light['on-secondary-container'],
          '& .MuiListItemIcon-root, & .MuiSvgIcon-root': {
            color: theme.palette.M3.sys.light['on-secondary-container'],
          },
        },
        '&.Mui-selected': {
          backgroundColor: theme.palette.M3.sys.light['secondary-container'],
          color: theme.palette.M3.sys.light['on-secondary-container'],
          '& .MuiListItemIcon-root, & .MuiSvgIcon-root': {
            color: theme.palette.M3.sys.light['on-secondary-container'],
          },
        },
        '&.Mui-selected:hover': {
          backgroundColor: theme.palette.M3.sys.light['secondary-container'],
        },
      },
    },
  };

  return {
    components: {
      MuiMenu: menuTheme,
      MuiMenuItem: menuItemTheme,
    },
  };
};

export default getMenuTheme;
